export function getUrgentJobList(data) {
    let { getUrgentJobListRequest, getUrgentJobListError, getUrgentJobListResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'get_urgent_job_list',
        this.createBundle('get_urgent_job_list', { unused: data }, this.GET, getUrgentJobListRequest, getUrgentJobListResult, getUrgentJobListError)
    )
}
